export function getLinkTag(namespace, doc) {
    const link = doc.createElement('link');
    link.href = `${location.origin}/build/${namespace}.css`;
    link.rel = 'stylesheet';
    return link;
}
export function getScriptModuleTag(namespace, doc) {
    const script = doc.createElement('script');
    script.src = `${location.origin}/build/${namespace}.esm.js`;
    script.setAttribute('type', 'module');
    script.setAttribute('data-stencil-namespace', namespace);
    return script;
}
export function getScriptNoModuleTag(namespace, doc) {
    const script = doc.createElement('script');
    script.src = `${location.origin}/build/${namespace}.js`;
    script.setAttribute('nomodule', '');
    script.setAttribute('data-stencil-namespace', namespace);
    return script;
}
